import type { ReactNode } from 'react';
import React from 'react';

import { LiveVideoModal } from '../common/modal/LiveVideoModal.component';
import styles from './MogulLive.module.css';

export const MogulLive = ({
  setModal,
  video,
  title,
  date,
  body,
}: {
  setModal: (node: ReactNode) => void;
  video: string;
  title: string;
  date: string;
  body: string;
}) => {
  const [thumbnail, setThumbnail] = React.useState('');
  const [showMore, setShowMore] = React.useState(false);
  const [videoId, setVideoId] = React.useState('');

  const openVideoModal = () => {
    setModal(LiveVideoModal(videoId));
  };

  React.useEffect(() => {
    try {
      const newVideoId = video.split('v=')[1];
      setVideoId(newVideoId);
      setThumbnail(`http://img.youtube.com/vi/${newVideoId}/0.jpg`);
    } catch (e) {
      console.error('incorrect video provided: ', e);
      setThumbnail(`http://img.youtube.com/vi/9RbcokYrp9M/hqdefault.jpg`);
    }
  }, [video]);

  return (
    <div
      className={styles.mogulLiveContainer}
      onMouseEnter={() => {
        setShowMore(true);
      }}
      onMouseLeave={() => {
        setShowMore(false);
      }}
      role="button"
      tabIndex={0}
      onClick={openVideoModal}
      onKeyPress={() => {}}
    >
      <img src={thumbnail} alt="mogul live" className={styles.mogulLiveImage} />
      <div className={styles.mogulLiveTitle}>{title}</div>
      <div className={styles.mogulLiveDate}>{date}</div>
      <div
        className={
          showMore ? styles.mogulLiveBodyExtended : styles.mogulLiveBody
        }
      >
        {body}
      </div>
    </div>
  );
};
